import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography
} from "@material-ui/core";
import AIEvaluationChart from "./charts/ai-evaluation-chart";
import PerformanceDistributionChart from "./charts/performance-distribution-chart";
import TaskEvaluationChart from "./charts/task-evaluation-chart";
import { dashboardStyles } from "./styles";


export const QualitativeDashboard = ({ data }) => {
    const classes = dashboardStyles()

    const metrics = [...data?.metrics, ...data?.averagePerformance]

    const evaluationChartData = data.metrics.slice(1, 3)
    const aiEvaluationChartData = data.metrics.slice(-2)

    return (
        <>
            <Box mt={3}>
                <Grid container spacing={2}>
                    {metrics?.map((metric) => (
                        <Grid item xs={12} sm={6} md={3} key={metric.label}>
                            <Card className={classes.metricCard}>
                                <CardContent>
                                    <Typography className={classes.metricLabel}>
                                        {metric.label}
                                    </Typography>

                                    <Typography className={classes.metricValue}>
                                        {`${metric.value} ${metric.decoration || ''}`}
                                    </Typography>

                                    <Typography className={classes.metricVariation}>
                                        {metric.variation}
                                    </Typography>
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Box>
            <Box mt={3}>
                <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                        <Card className={classes.filtersCard}>
                            <CardContent>
                                <Typography className={classes.sectionTitle}>
                                    Correção de atividades
                                </Typography>
                                {
                                    data &&
                                    <TaskEvaluationChart
                                        data={evaluationChartData}
                                    />
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card className={classes.filtersCard}>
                            <CardContent>
                                <Typography className={classes.sectionTitle}>
                                    Tipos de correção
                                </Typography>
                                {
                                    data &&
                                    <AIEvaluationChart
                                        data={aiEvaluationChartData}
                                    />
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Card className={classes.filtersCard}>
                            <CardContent>
                                <Typography className={classes.sectionTitle}>
                                    Distribuição de performance
                                </Typography>
                                {
                                    data &&
                                    <PerformanceDistributionChart
                                        data={data?.performanceDistribution}
                                    />
                                }
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Box>
        </>
    )
}